export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder || (SortOrder = {}));
export var MessageRole;
(function (MessageRole) {
    MessageRole["System"] = "system";
    MessageRole["User"] = "user";
    MessageRole["Assistant"] = "assistant";
    MessageRole["Tool"] = "tool";
    MessageRole["Reasoning"] = "reasoning";
    MessageRole["Error"] = "error";
})(MessageRole || (MessageRole = {}));
export var AgentAttachmentType;
(function (AgentAttachmentType) {
    AgentAttachmentType["File"] = "file";
    AgentAttachmentType["Link"] = "link";
    AgentAttachmentType["Artifact"] = "artifact";
    AgentAttachmentType["Context"] = "context";
})(AgentAttachmentType || (AgentAttachmentType = {}));
export var AgentToolCallStatus;
(function (AgentToolCallStatus) {
    AgentToolCallStatus["Pending"] = "pending";
    AgentToolCallStatus["Running"] = "running";
    AgentToolCallStatus["Succeeded"] = "succeeded";
    AgentToolCallStatus["Failed"] = "failed";
})(AgentToolCallStatus || (AgentToolCallStatus = {}));
export var AgentProcessStatus;
(function (AgentProcessStatus) {
    AgentProcessStatus["Queued"] = "queued";
    AgentProcessStatus["ApprovalRequired"] = "approvalRequired";
    AgentProcessStatus["Running"] = "running";
    AgentProcessStatus["Paused"] = "paused";
    AgentProcessStatus["Error"] = "error";
    AgentProcessStatus["Complete"] = "complete";
})(AgentProcessStatus || (AgentProcessStatus = {}));
export var StreamChunkType;
(function (StreamChunkType) {
    StreamChunkType["Message"] = "message";
    StreamChunkType["Reasoning"] = "reasoning";
    StreamChunkType["Tool"] = "tool";
    StreamChunkType["Artifact"] = "artifact";
    StreamChunkType["Error"] = "error";
    StreamChunkType["Chat"] = "chat";
})(StreamChunkType || (StreamChunkType = {}));
export var ChatType;
(function (ChatType) {
    ChatType["Chat"] = "chat";
    ChatType["Agent"] = "agent";
})(ChatType || (ChatType = {}));
export var AgentStatus;
(function (AgentStatus) {
    AgentStatus["Processing"] = "processing";
    AgentStatus["Streaming"] = "streaming";
    AgentStatus["Finished"] = "finished";
    AgentStatus["Aborted"] = "aborted";
    AgentStatus["WaitingForUserAction"] = "waitingForUserAction";
    AgentStatus["Error"] = "error";
    AgentStatus["Timedout"] = "timedout";
})(AgentStatus || (AgentStatus = {}));
export var AgentToolType;
(function (AgentToolType) {
    AgentToolType["API_TOOL"] = "api_tool";
    AgentToolType["WEB_SEARCH"] = "web_search";
    AgentToolType["LOCAL_FUNCTION"] = "local_function";
    AgentToolType["SUBAGENT"] = "subagent";
    AgentToolType["REQUEST_CLARIFICATION"] = "request_clarification";
    AgentToolType["IMAGE_GENERATION"] = "image_generation";
})(AgentToolType || (AgentToolType = {}));
export var ActivityOperationName;
(function (ActivityOperationName) {
    ActivityOperationName["MESSAGE_PROCESSING"] = "messageProcessing";
    ActivityOperationName["AGENT_SELECTION"] = "agentSelection";
    ActivityOperationName["STEP_FINISHED"] = "stepFinished";
    ActivityOperationName["TITLE_GENERATION"] = "titleGeneration";
    ActivityOperationName["RESPONSE_DECISION"] = "responseDecision";
    ActivityOperationName["SUBAGENT"] = "subagent";
})(ActivityOperationName || (ActivityOperationName = {}));
export var ActivitySourceType;
(function (ActivitySourceType) {
    ActivitySourceType["AGENT_MESSAGE"] = "AgentMessage";
    ActivitySourceType["CHAT"] = "Chat";
    ActivitySourceType["UNKNOWN"] = "Unknown";
})(ActivitySourceType || (ActivitySourceType = {}));
//# sourceMappingURL=enums.js.map